import {
  DEFAULT_HORIZONTAL_ROTATION_SPEED,
  DEFAULT_PAN_SPEED,
  DEFAULT_VERTICAL_ROTATION_SPEED,
  DEFAULT_ZOOM_SPEED,
} from '../../constants/validationConstants';

export const CURATOR_SETTING = {
  // metadata comes also from api
  metaData: [
    {
      id: 3,
      key: 'Design',
      value: 'Texture Name',
      seq_no: 2,
      is_render: true,
      display_name: 'Design',
    },
    {
      id: 4,
      key: 'Part Name',
      value: 'Object Name',
      seq_no: 1,
      is_render: true,
      display_name: 'Part Name',
    },
    {
      id: 1,
      key: 'Repeat Size',
      value: 'Texture Dimention',
      seq_no: 4,
      is_render: true,
      display_name: 'Repeat Size',
    },
    {
      id: 2,
      key: 'SKU ID',
      value: 'SKU ID',
      seq_no: 3,
      is_render: true,
      display_name: 'Sku id',
    },
    {
      id: 6,
      key: 'Rotation',
      value: 'Texture Rotation',
      seq_no: 6,
      is_render: true,
      display_name: 'Rotation',
    },
    {
      id: 8,
      key: 'Test',
      value: 'Test',
      seq_no: 8,
      is_render: true,
      display_name: 'ABCD',
    },
    {
      id: 7,
      key: 'Content',
      value: 'Texture Descripton',
      seq_no: 7,
      is_render: false,
      display_name: 'Content',
    },
    {
      id: 5,
      key: 'Offset',
      value: 'Texture Offset',
      seq_no: 5,
      is_render: true,
      display_name: 'Offset',
    },
  ],
  measureUnit: [
    {
      id: 1,
      name: 'inches',
      isSelected: true,
    },
    {
      id: 2,
      name: 'feet',
      isSelected: false,
    },
    {
      id: 3,
      name: 'cm',
      isSelected: false,
    },
    {
      id: 4,
      name: 'meter',
      isSelected: false,
    },
  ],
  cameraSetting: {
    verticalRotationSpeed: DEFAULT_VERTICAL_ROTATION_SPEED,
    horizontalRotationSpeed: DEFAULT_HORIZONTAL_ROTATION_SPEED,
    zoomSpeed: DEFAULT_ZOOM_SPEED,
    panSpeed: DEFAULT_PAN_SPEED,
  },
  graphicQuality: [
    {
      id: 1,
      name: 'Fantastic',
      isSelected: true,
    },
    {
      id: 2,
      name: 'Good',
      isSelected: false,
    },
    {
      id: 3,
      name: 'Simple',
      isSelected: false,
    },
    {
      id: 4,
      name: 'Performance',
      isSelected: false,
    },
  ],
  resolutionPresent: [
    {
      id: 1,
      name: '1080p',
      width: 1920,
      height: 1080,
      isSelected: true,
      lock: true,
    },
    {
      id: 2,
      name: '1440p',
      width: 2560,
      height: 1440,
      isSelected: false,
      lock: true,
    },
    {
      id: 3,
      name: '4k',
      width: 3840,
      height: 2160,
      isSelected: false,
      lock: true,
    },
  ],
};
